import React, { useEffect, useState } from "react";
import styles from "./row.module.sass";
import Control from "./Control/index";
import { Link, useParams } from "react-router-dom";
import ProgressionSystem from '../../../../../../media/images/placeholders/Progression_System.png'
import TooltipGlodal from "../../../../../TooltipGlodal";
import cn from "classnames";
import { useDispatch } from "react-redux";
import { extarctImageFromUrlAction } from "../../../../../../redux/action/common/commonAction";
/* Deleted Schedule, Modal, Modal Products and Actions */

const Row = ({ item, className, access, value, onChange }) => {
    
    const {appid} = useParams()
    const dispatch = useDispatch()

    const extractImageFromCdn = async(url, id) => {
        if(url !== null && url !== undefined && url.includes('cdn')){
            try {
                const response = await dispatch(extarctImageFromUrlAction(url))
                const logo = document.getElementById(`psIcon_${id}`)
                if(logo){
                    logo.src = response
                }
            }catch (error){
                console.error('Error fetching image:', error);
            }
        }else{
            const logo = document.getElementById(`psIcon_${id}`)
            if(logo){
                logo.src = ProgressionSystem
            }
        }
    }

    useEffect(() => {
        extractImageFromCdn(item.iconUrl, item.id)
    }, [item])

    return (
        <>
            <div className={styles.row}>
                <div className={styles.col}>
                    <div className={styles.item}>
                        {item.iconUrl !== undefined ?
                            <div className={cn(styles.preview, className, {[styles.bg] : true})}>
                                <img id={`psIcon_${item.id}`} alt="PS" />
                            </div>
                            :
                            <div className={styles.preview}></div>
                        }
                        <div className={styles.details}>
                            <div>{item.name}</div>
                            <div>{item.levelSystemId}</div>
                        </div>
                    </div>
                </div>
                <div className={styles.col}>
                    <Link to={`/view-progression-system/${appid}/${item.id}`}>
                        <TooltipGlodal width={200} itemId={`PS${item.id}`} title={item.name}><div className={styles.itemName}><span id={`PS${item.id}`}>{item.name}</span></div></TooltipGlodal>
                        <div className={styles.itemId}>{item.levelSystemId}</div>
                    </Link>
                </div>
                
                <div className={styles.col}><div className={item.archive === false ? styles.price : item.archive === true ? styles.archive : null}>{item.archive === false ? 'Active' : item.archive === true ? 'Archive' : null}</div></div>
                <div className={styles.col}>
                    {Object.keys(item).length !== 0 &&
                        <Control access={access} className={styles.control} id={item.id} appid={appid} status={item.archive} name={item.name} type='ps' />
                    }
                </div>
            </div>
        </>
    );
};

export default Row;
